import { useEffect, useId, useState } from 'react'
import { listFollowing } from '../../api/users'

interface Props {
  value: string
  onChange: (v: string) => void
  currentUsername: string | null
  style?: React.CSSProperties
}

export function AssigneeInput({ value, onChange, currentUsername, style }: Props) {
  const [friends, setFriends] = useState<string[]>([])
  const listId = useId()

  useEffect(() => {
    if (!currentUsername) return
    listFollowing(currentUsername).then(setFriends).catch(() => {})
  }, [currentUsername])

  return (
    <div style={{ display: 'flex', gap: '0.3rem', ...style }}>
      <input
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder="assignee (optional)"
        list={listId}
        style={{ flex: 1 }}
      />
      <datalist id={listId}>
        {friends.map((u) => (
          <option key={u} value={u} />
        ))}
      </datalist>
      {currentUsername && (
        <button
          type="button"
          onClick={() => onChange(currentUsername)}
          style={{ width: 'auto', fontSize: '0.8rem', padding: '0 0.5rem' }}
          title="assign to myself"
        >
          me
        </button>
      )}
    </div>
  )
}
